import script from "./LiveNowSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveNowSection.vue?vue&type=script&setup=true&lang=js"

import "./LiveNowSection.vue?vue&type=style&index=0&id=0f7d009b&lang=scss"

const __exports__ = script;

export default __exports__